import {Route, RouteConfig} from 'vue-router';

import ReportPrintingPage from '@/modules/neodash/pages/report/printing/report-printing.page.vue';
import ReportPage from '@/modules/neodash/pages/report/report.page.vue';
import ReportUploadPage from '@/modules/neodash/pages/report/upload/report-upload.page.vue';
import ReportCenterPage from '@/modules/neodash/pages/report-center.page.vue';
import WorkbookPage from '@/modules/neodash/pages/workbook/workbook.page.vue';
import {lstCards, refactoredCardInfo, reportTypeEnum} from '@/modules/neodash/model/constants/cards';

export const REPORT_ROUTES = Object.freeze({
  REPORT_PRINTING_PAGE: 'report-printing-page',
  REPORT_UPLOAD_PAGE: 'report-upload-page',
  WORKBOOK_PAGE: 'workbook-page',
  REPORT_PAGE: 'report-page',
  REPORTS_PAGE: 'reports-page'
});

const refactoredReports: RouteConfig[] =
    lstCards
        .filter(x => x.reportType === reportTypeEnum.refactoredCard)
        .map(x => x as refactoredCardInfo)
        .map(({reportKey, component}) => ({
          name: reportKey,
          path: `/neodash/report/v2/${reportKey}`,
          component: component
        }));

export const reportRoutes: RouteConfig[] = [
  ...refactoredReports,
  {
    component: ReportPrintingPage,
    name: REPORT_ROUTES.REPORT_PRINTING_PAGE,
    path: `report/:reportName?/printing`,
    props: (route: Route) => ({reportName: route.params.reportName})
  },
  {
    component: ReportUploadPage,
    name: REPORT_ROUTES.REPORT_UPLOAD_PAGE,
    path: `report/:reportName?/upload`,
    props: (route: Route) => ({reportName: route.params.reportName})
  },
  {
    component: WorkbookPage,
    name: REPORT_ROUTES.WORKBOOK_PAGE,
    path: `workbook/:workbook?/:worksheet?`,
    props: (route: Route) => ({
      workbook: route.params.workbook,
      worksheet: route.params.worksheet
    })
  },
  {
    component: ReportPage,
    name: REPORT_ROUTES.REPORT_PAGE,
    path: `report/:reportName?/:subReportName?`,
    props: (route: Route) => ({
      reportName: route.params.reportName,
      subReportName: route.params.subReportName
    })
  },
  {
    component: ReportCenterPage,
    name: REPORT_ROUTES.REPORTS_PAGE,
    path: '/',
  }
];
